<div class="page-container">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="description">
        Customer service is our top priority at RTS. Please select one of the
        customer service options below to expedite your request.
      </div>
      <div class="row align-items-center buttons">
        <div class="col-12">
          <mat-form-field class="select-input" appearance="outline">
            <mat-label>Municipality*</mat-label>
            <mat-select
              [(value)]="selectedClient"
              placeholder="Select Municipality">
              <mat-option
                *ngFor="let dropdownOption of municipalitiesDropdownOptions"
                [value]="dropdownOption">
                {{ dropdownOption.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <ng-container *ngIf="selectedClient && selectedClient.options.length">
            <div class="row align-items-center buttons">
              <div
                *ngFor="let option of selectedClient.options; let i = index"
                class="col-12 button-container">
                <button
                  class="col-12 ticket-button"
                  [ngClass]="
                    isHover === i ? 'rts-filled-button' : 'rts-inverse-button'
                  "
                  (mouseover)="isHover = i"
                  (mouseout)="isHover = null"
                  (click)="buttonClicked(option)">
                  + {{ option }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <ng-template #popTemplate>
    <mat-icon>smart_toy</mat-icon>
    <ng-container>
      Please select one of the customer service options above to expedite your
      request or click here for details on existing cases.
    </ng-container>
  </ng-template>
  <button
    *ngIf="surveyLink"
    mat-mini-fab
    extended
    class="feedback-button"
    placement="top"
    containerClass="feedback-popover"
    triggers="focus"
    (click)="openFeedbackDialog(surveyLink)">
    <mat-icon>feedback</mat-icon>
  </button>
  <button
    mat-mini-fab
    extended
    class="chatbot-button"
    placement="top"
    [mdbPopover]="popTemplate"
    mdbWavesEffect
    containerClass="chatbot-popover"
    #pop="bs-mdbPopover"
    triggers="focus"
    (click)="openChatbotDialog(); pop.hide()">
    <mat-icon>smart_toy</mat-icon>
  </button>
</div>
